import React, { ReactNode } from 'react';

import { InfoBox } from '@infoods/lifebase-ui';
import { BasicInfoSection } from './sections/BasicInfoSection/BasicInfoSection';
import { DivisionsSection } from './sections/DivisionsSection/DivisionsSection';
import { HowItWorksSection } from './sections/HowItWorksSection/HowItWorksSection';
import { BannerSection } from './sections/BannerSection/BannerSection';
import { SolutionTypeFlags } from '../../../../shared/constants/user-info/solutionType';
import { Mode } from '../../../../general-types';
import { ChallengeBannerUploadType } from '../../../constants/challengeBannerUploadType';

type ChallengeAboutFormProps = {
  mode: Mode;
  availableSolutionsFlags: SolutionTypeFlags;
  headerActions?: ReactNode;
  disabledEditMainFields?: boolean;
  onUploadBanner: (bannerType: ChallengeBannerUploadType) => void;
};

export const ChallengeAboutForm = ({
  mode,
  availableSolutionsFlags,
  headerActions,
  disabledEditMainFields,
  onUploadBanner,
}: ChallengeAboutFormProps) => {
  return (
    <InfoBox title="About" adornment={headerActions} customContentPadding>
      <BasicInfoSection
        availableSolutionsFlags={availableSolutionsFlags}
        mode={mode}
        disabledEditMainFields={disabledEditMainFields}
      />
      <DivisionsSection mode={mode} />
      <HowItWorksSection mode={mode} />
      <BannerSection onUploadBanner={onUploadBanner} />
    </InfoBox>
  );
};
